"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import CommonTitle from "ui/common/bit/CommonTitle"
import { getNonUmbracoUrl } from "utils"
import { sendBlockEvent } from "utils/gtm"
import { extractBlockProperties } from "utils/simplifyData"
import BlockWrapper from "../common/BlockWrapper"
import FiltersWrapper from "../FiltersWrapper/FiltersWrapper"
import ActionCardListContainer from "./ActionCardListContainer"

const StyledButtonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
`

const ActionsCardsBlock = ({ data, id }: any) => {
  const { title, subtitle, actionsList, button, bgColor } = data
  const parsedActionsList = extractBlockProperties(actionsList?.blocks).map(
    (item: any) => {
      return {
        ...item,
        category: item.filter,
      }
    },
  )
  const categories = Array.from(
    new Set(
      parsedActionsList
        ?.map((item: any) => String(item.filter))
        .filter(
          (filter: string) =>
            Boolean(filter) && filter !== "null" && filter !== "",
        ),
    ),
  ) as string[]

  const handleCardClick = (buttonTitle: string) => {
    sendBlockEvent({
      blockId: id || "",
      title: title?.value,
      componentName: "שרות עצמי", // per your table
      buttonName: buttonTitle,
      productName: data?.formDefaultInsuranceType,
    })
  }

  return (
    <BlockWrapper id={id} bgColor={bgColor}>
      {(title || subtitle) && (
        <CommonTitle title={title?.value} subtitle={subtitle?.value} />
      )}
      <FiltersWrapper categories={categories} itemsList={parsedActionsList}>
        <ActionCardListContainer
          itemsList={parsedActionsList}
          onClick={handleCardClick}
        />
      </FiltersWrapper>
      {button && button?.links[0] && (
        <StyledButtonWrapper>
          <ButtonWithArrow
            href={getNonUmbracoUrl(button?.links[0]?.url)}
            onClick={() => {
              sendBlockEvent({
                blockId: id || "",
                title: title?.value,
                componentName: "שרות עצמי", // per your table
                buttonName: button.links[0]?.name,
                productName: data?.formDefaultInsuranceType,
              })
            }}
          >
            {button.links[0]?.name}
          </ButtonWithArrow>
        </StyledButtonWrapper>
      )}
    </BlockWrapper>
  )
}

export default ActionsCardsBlock
